/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TagDetailsResponse } from './tagDetailsResponse';

export interface ManagementTagCategoryResponse { 
    id?: string;
    value?: string;
    colorCode?: string;
    screenshot?: boolean;
    translate?: boolean;
    langs?: Array<ManagementTagCategoryResponse.LangsEnum>;
    details?: Array<TagDetailsResponse>;
    categoryId?: string;
}
export namespace ManagementTagCategoryResponse {
    export type LangsEnum = 'MK' | 'EN' | 'AL';
    export const LangsEnum = {
        MK: 'MK' as LangsEnum,
        EN: 'EN' as LangsEnum,
        AL: 'AL' as LangsEnum
    };
}